import React, {Component} from 'react';

class ConfirmedPlotsStatus extends Component {
    render() {
        return (
            <div>
                
            </div>
        );
    }
}

export default ConfirmedPlotsStatus;
